import { CertificateBanner, CERTIFICATE_LAYOUT, useIntl } from 'platform-components';
import React, { useCallback } from 'react';
import ym from 'react-yandex-metrika';

export const RoverBoardgameBanner = () => {
    const { formatMessage } = useIntl();

    const i18n = useCallback(
        (id: string) => formatMessage({ id: `specCourse.lessonView.roverBoardGame.${id}` }),
        [formatMessage]
    );

    const handleClick = useCallback(() => {
        ym('reachGoal', 'teacher_olymp_download_rover_boardgame_manual');

        window.open(i18n('manual'), '_blank');
    }, [i18n]);

    return (
        <CertificateBanner
            buttonText={i18n('buttonText')}
            description={i18n('description')}
            headerText={i18n('title')}
            imageSrc={i18n('previewImgSrc')}
            layout={CERTIFICATE_LAYOUT.WIDE}
            onClick={handleClick}
            showButton={true}
            theme="purple"
        />
    );
};
